//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    name: 'progressList',
    components: {},
    data() {
        const vm = this;
        return {
            loading: false,
            searchInput: {},
            columns: [
                {
                    type: 'index',
                    width: 60,
                    align: 'center'
                },
                {
                    title: '标题',
                    key: 'title',
                    align: 'center'
                },
                {
                    title: '城市名称',
                    key: 'cityName',
                    align: 'center'
                },
                {
                    title: '项目名称',
                    key: 'projectName',
                    align: 'center'
                },

                {
                    title: '时间',
                    align: 'center',
                    // key: 'projectName',
                    render: (h, params) => {
                        const row = params.row;
                        return h('span', row.year + '年' + row.month + '月');
                    }
                },
                {
                    title: '上传人',
                    key: 'uploaderName',
                    align: 'center'
                },
                {
                    title: '上传时间',
                    key: 'uploadTimeStr',
                    align: 'center'
                    // render: (h, params) => {
                    //     return h('span', new Date(params.row.uploadTime).toLocaleDateString());
                    // }
                },
                {
                    title: '审核状态',
                    key: 'auditStatus',
                    align: 'center',
                    render: (h, params) => {
                        const row = params.row;
                        if (row.auditStatus === 1) {
                            return h('span', '已审核');
                        } else {
                            return h('span', '未审核');
                        }

                    }
                },
                {
                    title: '操作', align: 'center',
                    render: (h, params) => {
                        const row = params.row;
                        const actions = [];

                        var del = h('Button', {
                            props: {
                                type: 'error',
                                size: 'small'
                            },
                            style: {
                                marginRight: '5px'
                            },
                            on: {
                                click: () => {
                                    // vm.delOwner(params.row);
                                }
                            }
                        }, '删除');

                        var edit = h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small'
                            },
                            style: {
                                marginRight: '5px'
                            },
                            on: {
                                click: () => {
                                    vm.progressDetail(params.row);
                                }
                            }
                        }, '查看');

                        actions.push(edit);
                        // actions.push(del);
                        return h('div', actions);
                    }
                }
            ],
            months: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
            years: [],
            projects: []
        };
    },
    methods: {
        pageChange(page) {
            this.$store.commit('progress/setCurrentPage', page);
            this.getPage();
        },
        pageSizeChange(pagesize) {
            this.$store.commit('progress/setPageSize', pagesize);
            this.getPage();
        },
        async getPage() {
            this.loading = true;
            await this.$store.dispatch({
                type: 'progress/getAll',
                data: this.searchInput
            }).finally(() => {
                this.loading = false;
            });
        },
        addProgress(row) {
            this.$router.push({ path: '/progressEdit/' + row.id });
        },
        progressDetail(row) {
            this.$router.push({ path: '/progressDetail/' + row.id });
        },
        getProjects() {
            this.$store.dispatch({
                type: 'project/getProjects'
            }).then(() => {
                this.projects = this.$store.state.project.projects;
            });
        },
        hasPermission(permission) {
            return abp.auth.isGranted(permission);
        }
    },
    computed: {
        currentPage() {
            return this.$store.state.progress.currentPage;
        },
        totalCount() {
            return this.$store.state.progress.totalCount;
        },
        pageSize() {
            return this.$store.state.progress.pageSize;
        },
        list() {
            return this.$store.state.progress.list;
        }

    },
    created() {
        this.getPage();
        this.getProjects();
        var y = new Date().getFullYear();
        this.years = [];
        for (let j = 5; j > 0; j--) {
            this.years.push(y - j);
        }
        for (let i = 0; i < 6; i++) {
            this.years.push(y + i);
        }
        // console.log(years);

    }
};
